module.exports = __webpack_public_path__ + "static/media/dental1.1055514d.webp";